import Colors from '../../../../shared/assets/style/default/color';
import styled from 'styled-components';

const PauseAdContainer = styled.div<{
  delay?: number;
  duration?: number;
  opacity?: number;
}>`
  transition: opacity ${(props) => props.duration}ms ease-in-out
    ${(props) => props.delay}ms;
  opacity: ${(props) => props.opacity};
  background: ${Colors.background};
  display: flex;
  height: 100vh;
  justify-content: center;
  position: absolute;
  width: 100vw;
  z-index: 2;
`;

export default PauseAdContainer;
